import { render, staticRenderFns } from "./listFeedback.vue?vue&type=template&id=6bcc3528&scoped=true&"
import script from "./listFeedback.vue?vue&type=script&lang=js&"
export * from "./listFeedback.vue?vue&type=script&lang=js&"
import style0 from "./listFeedback.vue?vue&type=style&index=0&id=6bcc3528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcc3528",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAvatar,VCard,VIcon,VTextField,VToolbar})
